import { render, staticRenderFns } from "./EntityIcon.vue?vue&type=template&id=6f4af4c0"
import script from "./EntityIcon.vue?vue&type=script&lang=js"
export * from "./EntityIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports